'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _reactUtils = require('react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UIAbstractPageSection',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    children: _react.PropTypes.node,
    className: _react.PropTypes.string
  },

  render: function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        rest = _objectWithoutProperties(_props, ['children', 'className']);

    return _react2.default.createElement(
      'section',
      _extends({}, rest, {
        className: (0, _reactUtils.classNames)('private-template__section', className)
      }),
      children
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/page/UIAbstractPageSection.js
// module id = 173
// module chunks = 0